import WrapperModal from '../ui/WrapperModal';

import './StepProgressBar.scss';

const StepProgressBar = ({ steps, currentStep = 0 }) => {
	return (
		<WrapperModal
			withBackdrop={false}
			modalControls={false}
			topAnchored={true}
		>
			<div className='steps-container'>
				{steps.map((step, i) => {
					const isStepActive = currentStep >= i;
					const itemClassName = `step-item${
						isStepActive ? ' active' : ''
					}`;
					const isStepPast = currentStep > i;
					const barClassName = `step-bar${
						isStepPast ? ' active' : ''
					}`;
					return (
						<div
							key={step.id}
							className={itemClassName}
							style={{ width: `${100 / steps.length}%` }}
						>
							<span className='step-label'>
								{step.label}
							</span>
							<div className={barClassName}></div>
							<div className='step-bullet'></div>
						</div>
					);
				})}
			</div>
		</WrapperModal>
	);
};

export default StepProgressBar;
